(() => {
  if (window.levianBestsellersInitialized) return;
  window.levianBestsellersInitialized = true;
  function init(root = document) {
    root.querySelectorAll('[data-levian-autoplay]').forEach(component => {
      if (component.dataset.ready) return;
      const track = component.querySelector('.product-grid');
      const toggle = component.querySelector('[data-carousel-toggle]');
      const originals = Array.from(track?.children || []);
      if (originals.length < 2 || !toggle || !track.animate) return;
      component.dataset.ready = 'transform';
      const events = new AbortController();
      const listen = (element, name, fn, options = {}) => element.addEventListener(name, fn, {...options, signal: events.signal});
      const viewport = document.createElement('div');
      viewport.className = 'levian-carousel-viewport';
      track.before(viewport);
      viewport.append(track);
      track.scrollLeft = 0;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const canHover = matchMedia('(hover: hover) and (pointer: fine)');
      const speed = Math.max(24, Math.min(60, (Number(component.dataset.speed) || 18) * 2));
      let paused = reduce.matches, hovered = false, focused = false, touching = false, visible = false;
      let animation, cycle = 0, duration = 0, pointer, suppressClick = false;
      const clones = originals.map(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        [clone, ...clone.querySelectorAll('[id]')].forEach(el => el.removeAttribute('id'));
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
        clone.querySelectorAll('[aria-labelledby],[aria-describedby],[aria-controls]').forEach(el => {
          el.removeAttribute('aria-labelledby'); el.removeAttribute('aria-describedby'); el.removeAttribute('aria-controls');
        });
        clone.querySelectorAll('img').forEach(img => {img.loading = 'eager'; img.setAttribute('fetchpriority', 'low');});
        track.append(clone);
        return clone;
      });
      const wrap = value => cycle ? ((value % cycle) + cycle) % cycle : 0;
      const position = () => duration ? wrap((Number(animation?.currentTime) || 0) / duration * cycle) : 0;
      const seek = value => {if (animation) animation.currentTime = wrap(value) / cycle * duration;};
      const sync = () => {
        if (!animation) return;
        if (paused || hovered || focused || touching || !visible || document.hidden) animation.pause();
        else animation.play();
      };
      const update = () => {
        toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
        toggle.setAttribute('aria-pressed', String(paused)); sync();
      };
      const measure = () => {
        const distance = clones[0].offsetLeft - originals[0].offsetLeft;
        if (distance <= 0 || (animation && Math.abs(distance - cycle) < 0.1)) return;
        const fraction = cycle ? position() / cycle : 0;
        animation?.cancel(); cycle = distance; duration = cycle / speed * 1000;
        animation = track.animate([{transform:'translate3d(0,0,0)'},{transform:`translate3d(${-cycle}px,0,0)`}], {duration,iterations:Infinity,easing:'linear'});
        animation.pause(); animation.currentTime = fraction * duration;
        component.dataset.motionSpeed = String(speed); sync();
      };
      listen(toggle, 'click', () => {paused = !paused; update();});
      listen(viewport, 'mouseenter', () => {hovered = canHover.matches; sync();});
      listen(viewport, 'mouseleave', () => {hovered = false; sync();});
      listen(canHover, 'change', () => {hovered = false; sync();});
      listen(reduce, 'change', e => {paused = e.matches; update();});
      listen(document, 'visibilitychange', sync);
      listen(track, 'focusin', e => {
        focused = e.target.matches(':focus-visible'); sync();
        if (!focused) return;
        const item = e.target.closest('.grid__item');
        if (item) seek(item.offsetLeft - originals[0].offsetLeft);
        viewport.scrollLeft = 0;
      });
      listen(track, 'focusout', () => {requestAnimationFrame(() => {focused = track.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); sync();});});
      listen(viewport, 'pointerdown', e => {
        if (!e.isPrimary || e.button !== 0) return;
        suppressClick = false; touching = true; sync();
        pointer = {id:e.pointerId,x:e.clientX,y:e.clientY,position:position(),dragging:false};
      });
      listen(viewport, 'pointermove', e => {
        if (!pointer || pointer.id !== e.pointerId) return;
        const dx = e.clientX-pointer.x, dy = e.clientY-pointer.y;
        if (!pointer.dragging && Math.abs(dx)>8 && Math.abs(dx)>Math.abs(dy)) {
          pointer.dragging = true; viewport.setPointerCapture(e.pointerId);
        }
        if (!pointer.dragging) return;
        e.preventDefault(); suppressClick = true; seek(pointer.position-dx);
      });
      const release = e => {
        if (!pointer || pointer.id !== e.pointerId) return;
        if (viewport.hasPointerCapture(e.pointerId)) viewport.releasePointerCapture(e.pointerId);
        pointer = null; touching = false; sync();
      };
      listen(window, 'pointerup', release); listen(window, 'pointercancel', release);
      listen(viewport, 'click', e => {
        if (suppressClick) {e.preventDefault(); e.stopPropagation(); suppressClick=false;}
      }, {capture:true});
      listen(viewport, 'dragstart', e => e.preventDefault());
      listen(viewport, 'wheel', e => {
        if (Math.abs(e.deltaX)<=Math.abs(e.deltaY)) return;
        e.preventDefault(); seek(position()+e.deltaX);
      }, {passive:false});
      const resize = new ResizeObserver(measure); resize.observe(viewport);
      const intersection = new IntersectionObserver(entries => {visible=entries[0].isIntersecting; sync();});
      intersection.observe(component);
      listen(document, 'shopify:section:unload', e => {
        if (!e.target.contains(component)) return;
        animation?.cancel(); resize.disconnect(); intersection.disconnect(); events.abort();
      });
      measure(); update();
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init());
  else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
